import { Modal, Form, Input, InputNumber, Switch } from "antd";
import { useEffect } from "react";

import SlugFormItem from "src/components/CourseContentManagement/ModulesManagement/SlugFormItem";

const CreateEditSetModal = ({
  open,
  onCancel = () => {},
  onCreate = () => {},
  onUpdate = () => {},
  initialValues = {},
  loading,
  entityName = "Set"
}) => {
  const [form] = Form.useForm();
  const isEdit = !!initialValues && Object.keys(initialValues).length > 0;
  // isOpenByDefault applies only to Lecture Sets (problem sets aren't independently expandable)
  const isLectureSet = entityName === "Lecture Set";

  useEffect(() => {
    if (open) {
      form.resetFields();
      if (isEdit) {
        form.setFieldsValue(initialValues);
      } else {
        // Default values for new set
        form.setFieldsValue({
          isVisible: true,
          moduleDisplayOrder: 1,
          ...(isLectureSet && { isOpenByDefault: false })
        });
      }
    }
  }, [open, initialValues, form, isLectureSet, isEdit]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (isEdit) {
          onUpdate(values);
        } else {
          onCreate(values);
        }
      })
      .catch((info) => {
        console.error("Validate Failed:", info);
      });
  };

  return (
    <Modal
      open={open}
      title={isEdit ? `Edit ${entityName}` : `Create New ${entityName}`}
      okText={isEdit ? "Update" : "Create"}
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={{ isVisible: true, moduleDisplayOrder: 1 }}
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[
            {
              required: true,
              message: `Please input the title of the ${entityName.toLowerCase()}!`
            }
          ]}
        >
          <Input />
        </Form.Item>

        <SlugFormItem
          isEdit={isEdit}
          entityName={entityName.toLowerCase()}
          reservedSlugs={initialValues?.reservedSlugs}
        />

        <Form.Item
          name="moduleDisplayOrder"
          label="Display Order in Module"
          rules={[
            {
              required: true,
              message: "Please input the display order!"
            }
          ]}
        >
          <InputNumber min={1} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="isVisible" label="Visible" valuePropName="checked">
          <Switch />
        </Form.Item>

        {isLectureSet && (
          <Form.Item
            name="isOpenByDefault"
            label="Open by Default in Sidebar"
            valuePropName="checked"
            tooltip="When ON, this set renders expanded by default in the learner module sidebar. The set containing the learner's last-viewed item is always expanded regardless."
          >
            <Switch />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default CreateEditSetModal;
